// Utility functions and types for contract handling

/**
 * Interface for contract data returned by the API
 */
export interface ContractData {
  title: string;
  disclaimer?: string;
  acceptance?: string;
  sections: Array<{
    title: string;
    content?: string;
    subsections?: Array<{
      title?: string;
      content?: string;
    }>;
  }>;
}

/**
 * Fixes malformed HTML entities in contract text
 * Corrects missing semicolons in HTML entities like &ldquo, &rdquo
 * @param str - The string with potentially malformed entities
 * @returns The corrected string
 */
export const fixMalformedEntities = (str: string): string => {
  return str
    .replace(/&ldquo/g, '&ldquo;')
    .replace(/&rdquo/g, '&rdquo;')
    .replace(/&ldquopiattaforma/g, '&ldquo;piattaforma&rdquo;');
};
